{"schemaVersion":1,"release":{"version":"1.0.9","build":157,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.0.9-157.dmg","sha256":"e7bd252fc6091d6bbe22af94394b3c64c76f3c73ee23bff173f61db12ee5a528","size":29047833}}
